import { Injectable } from '@angular/core';
import { AppointmentModel, ENDPOINTS, ODataAppointmentSlotsPayload, OnlineOnlyService } from '@evorait/pace-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OdataAppointmentSlotResponseModel, OdataSlotIntervalModel } from './appointment-booking-model';

@Injectable({
    providedIn: 'root',
})
export class AppointmentBookingService {
    public constructor(private readonly onlineOnlyService: OnlineOnlyService) {}

    public getAppointment(payload: ODataAppointmentSlotsPayload): Observable<OdataSlotIntervalModel[]> {
        return this.onlineOnlyService.post<OdataAppointmentSlotResponseModel>(ENDPOINTS.AppointmentGet, payload).pipe(
            map((response: OdataAppointmentSlotResponseModel) => {
                if (response) {
                    return AppointmentModel.fromODataAppointmentSlots(response).slotIntervals;
                }
                throw new Error(`AppointmentBookingService: getAppointment: Could not get appointment slots!`);
            }),
        );
    }
}
